export function useInfo() {
	const nuxtApp = useNuxtApp();

	// fetch info data
	async function fetch() {
		const res = await useApi('/api/nuxtapi/info/', null, {cache: true});
		nuxtApp.$appData.info = res?.data ? res.data : null;
		return res?.data ? res.data : null;
	}

	// get info data
	function getInfo(data) {
		const info = nuxtApp.$appData?.info;
		if (!data) return info;
		return info?.[data] ? info[data] : '';
	}

	function set(data) {
		nuxtApp.$appData.info = data;
	}

	return {info: getInfo(), fetch, getInfo, set};
}
